import FunctionModel from "../FunctionModel";
import IFunction from "../Interface/IFunction";

export default class FunctionBuilder {
    private _function: IFunction;

    constructor() {
        this._function = new FunctionModel();
    }

    /**
     * @description Obtengo el ID
     * @returns {number | string} value
     */
    public getId = (): number | string => this._function.id;

    /**
     * @description Obtengo el nombre
     * @returns {string} value
     */
    public getName = (): string => this._function.name;

    /**
     * @description Obtengo la lista de perfilessi contiene
     * @returns {FunctionModel[] | undefined} Si contiene retorna una lista y sino undefined
     */
    public getRelateFunction = (): FunctionModel[] | undefined => this._function.relateFunc;

    /**
     * @description Setea el id de la funci�n
     * @param {string | number} id identificador de la funcion
     * @returns {FunctionBuilder}
     */
    public setId = (id: string | number): FunctionBuilder => {
        this._function.id = id;
        return this;
    }

    /**
     * @description Setea el nombre de la funci�n
     * @param {string} name Nombre de la funci�n
     * @returns {FunctionBuilder}
     */
    public setName = (name: string): FunctionBuilder => {
        this._function.name = name;
        return this;
    }

    /**
     * @description Verifica si esta inicalizado la funciones relacionadas,
     * inicializa y agrega un elemento o un conjunto de elementos
     * @param { fnc?: IFunction, lstfnc?: IFunction[] } inData recibe un elemento o una lista de elementos
     */
    private relateFuncAdd = (inData: { fnc?: IFunction, lstfnc?: IFunction[] }): void => {
        if (!this._function.relateFunc) {
            this._function.relateFunc = [];
        }

        if (inData.fnc) {
            this._function.relateFunc = [...this._function.relateFunc, inData.fnc];
        }

        if (inData.lstfnc) {
            this._function.relateFunc = [...this._function.relateFunc, ...inData.lstfnc];
        }
    }

    /**
     * @description Agrega una funci�n
     * @param {IFunction} fnc cunci�n a agregar
     * @returns {FunctionBuilder}
     */
    public setRelateFunction = (fnc: IFunction): FunctionBuilder => {
        this.relateFuncAdd({ fnc });
        return this;
    }

    /**
     * @description Agrega una lista de funciones
     * @param {IFunction[]} lstfnc Lista de funciones
     * @returns {FunctionBuilder}
     */
    public setRelateListFunction = (lstfnc: IFunction[]): FunctionBuilder => {
        this.relateFuncAdd({ lstfnc });
        return this;
    }

    /**
     * @description Obtener el objeto creado.
     * @returns {FunctionModel} Retorna un perfil
     */
    public get = (): FunctionModel => this._function;
}
